import { createApp } from 'vue';
import { Datepicker } from 'vanillajs-datepicker';
import no from './../../node_modules/vanillajs-datepicker/js/i18n/locales/no.js'
import holidays from './holidays';
import deliveryDays from './../../../BrodrRingstad.ClientSide/store/deliverydays.js';

if ($('#checkout').length) {

    Object.assign(Datepicker.locales, no);

    const allDays = [0, 1, 2, 3, 4, 5, 6];

    let app = createApp({
        data() {
            return {
                customer: { deliveryDays: [] },
                currentYear: new Date().getFullYear(),
                currentHolidays: [],
                deliveryAddressId: 0,
                deliveryAddress: {},
                deliveryAddressLines: ""
            }
        },
        mounted() {
            this.customer = JSON.parse(this.$refs.customer.value);
            this.deliveryAddressId = this.customer.deliveryAddress.id;
            const useDeliveryDays = this.customer.deliveryDays.map(x => (x.index + 1) % 7);
            let date = deliveryDays.nextAvailableDelivery();
            this.currentYear = date.getFullYear();
            this.currentHolidays = holidays.findAllHolidays(this.currentYear);
            const dp = new Datepicker(this.$refs.deliveryDate, {
                format: 'dd.mm.yyyy',
                buttonClass: 'btn',
                language: 'no',
                beforeShowDay: (d) => {
                    let enabled = this.currentHolidays.filter(hd => hd.getTime() === d.getTime()).length === 0;
                    return {
                        enabled: enabled
                    };
                },
                daysOfWeekDisabled: allDays.filter(d => useDeliveryDays.indexOf(d) === -1),
                datesDisabled: this.currentHolidays,
                minDate: date
            });
            this.$refs.deliveryDate.addEventListener("changeYear",
                (e) => {
                    this.currentYear = e.detail.viewDate.getFullYear();
                    this.currentHolidays = holidays.findAllHolidays(this.currentYear);
                });

            this.$refs["checkout-form"].addEventListener('submit', () => {
                this.$refs["submit-button"].disabled = true;
            });
        },
        watch: {
            deliveryAddressId() {
                this.deliveryAddress = this.customer.deliveryAddresses.find(x => x.id == this.deliveryAddressId);
                this.deliveryAddressLines = `
                    ${this.deliveryAddress.line1 ?? ""}<br/>
                    ${this.deliveryAddress.line2 ? this.deliveryAddress.line2 + "<br/>" : ""}
                    ${this.deliveryAddress.line3 ? this.deliveryAddress.line3 + "<br/>" : ""}
                    ${this.deliveryAddress.postalCode ?? ""} ${this.deliveryAddress.postalArea ?? ""}
                `;
            }
        }

    });

    app.mount('#checkout');

}